import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/organisations/[slug]/manage/calendar?project_id&pivot'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type CalendarPageProps = PageProps<typeof pageUrl>
